import { render, staticRenderFns } from "./ResourceFooter.vue?vue&type=template&id=1497d39b&scoped=true"
import script from "./ResourceFooter.vue?vue&type=script&lang=js"
export * from "./ResourceFooter.vue?vue&type=script&lang=js"
import style0 from "./ResourceFooter.vue?vue&type=style&index=0&id=1497d39b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497d39b",
  null
  
)

export default component.exports